module.exports = __webpack_public_path__ + "static/media/logo2.b47f08d8.png";